import { FC, PropsWithChildren, createContext, useContext } from 'react';
import { useAudioSyncService, SyncStatus } from '../hooks/useAudioSyncService';

interface AudioSyncContextType {
  syncStatus: SyncStatus;
  pendingCount: number;
  failedCount: number;
  isOnline: boolean;
  uploadProgressMap: Record<string, { progress: number; step?: string; details?: string }>;
  triggerSync: (referenceId?: string | number) => Promise<void>;
}

const AudioSyncContext = createContext<AudioSyncContextType | undefined>(
  undefined,
);

export const AudioSyncProvider: FC<PropsWithChildren> = ({ children }) => {
  const sync = useAudioSyncService();

  return (
    <AudioSyncContext.Provider value={sync}>
      {children}
    </AudioSyncContext.Provider>
  );
};

export const useAudioSync = () => {
  const context = useContext(AudioSyncContext);
  if (context === undefined) {
    throw new Error('useAudioSync must be used within an AudioSyncProvider');
  }
  return context;
};
